import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, UserPlus } from "lucide-react";

export default function Setup() {
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/auth/setup-status").then(({ data }) => {
      if (!data.needs_setup) nav("/login", { replace: true });
    }).catch(() => {});
  }, [nav]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setToken(data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      toast.success("Conta criada!");
      nav("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha ao criar conta");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-muted/40">
      <form onSubmit={submit} className="w-full max-w-md surface p-8 space-y-6" data-testid="setup-form">
        <div>
          <h1 className="text-3xl font-display font-bold tracking-tight">Configure seu estabelecimento</h1>
          <p className="text-sm text-muted-foreground mt-2">Crie a conta de administrador para começar.</p>
        </div>
        <div className="space-y-2">
          <Label>Nome completo</Label>
          <Input data-testid="input-setup-name" required className="h-12" value={form.name} onChange={set("name")} />
        </div>
        <div className="space-y-2">
          <Label>Email</Label>
          <Input data-testid="input-setup-email" type="email" required className="h-12" value={form.email} onChange={set("email")} />
        </div>
        <div className="space-y-2">
          <Label>Senha (mín. 6 caracteres)</Label>
          <Input data-testid="input-setup-password" type="password" minLength={6} required className="h-12" value={form.password} onChange={set("password")} />
        </div>
        <Button data-testid="btn-submit-setup" disabled={loading} className="w-full h-12">
          {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <UserPlus className="h-4 w-4 mr-2" />}
          Criar conta admin
        </Button>
      </form>
    </div>
  );
}
